module.exports = __webpack_public_path__ + "static/img/Ace of Pentacles.0834a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ace of Pentacles.jpg
// module id = 1257
// module chunks = 0